import React, { useState } from 'react'
import Carousel from 'react-bootstrap/Carousel'
import './form.css'
import bg1 from '../../assets/images/bg1.jpg'
import bg2 from '../../assets/images/bg2.jpg'
import bg3 from '../../assets/images/bg3.jpg'

const Form = ({ submitdatasearch }) => {
  const [location, setLocation] = useState('')
  const onSubmit = (e) => {
    e.preventDefault()
    if (!location || location === '') {
      alert('Invalid Location or Empty Field')
    }
    submitdatasearch(location)
  }
  return (
    <div>
      <div className='main_wrap'>
        <div className='main_container'>
          <Carousel indicators={false} controls={false}>
            <Carousel.Item>
              <div className='slide_item'>
                <div className='bg1'></div>
              </div>
            </Carousel.Item>

            <Carousel.Item>
              <div className='slide_item'>
                <div className='bg3'></div>
              </div>
            </Carousel.Item>

            <Carousel.Item>
              <div className='slide_item'>
                <div className='bg5'></div>
              </div>
            </Carousel.Item>
          </Carousel>
          <form onSubmit={onSubmit} className='form'>
            <div className='input_form'>
              <input
                type='search'
                placeholder='Find your location....'
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              />
              <button type='submit'>Search</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Form
